const testimonials = [
  {
    quote:
      "I had 8k sitting in a savings account for years doing nothing. Leo walked me through opening a brokerage, picking my first stocks, and now my money is actually growing — not the bank's.",
    name: "Marco D.",
    title: "First-time investor",
  },
  {
    quote:
      "I'm a parent, not a finance person. Leo explained things in a way that finally made sense and built me a plan I can actually stick to. Outperformed my old advisor in 6 months.",
    name: "Sofia R.",
    title: "Long-term wealth plan",
  },
  {
    quote:
      "His stock picks are genuinely solid and the returns speak for themselves. More importantly he taught me why each one is in the portfolio, not just what to buy.",
    name: "Jakub W.",
    title: "Stock picks mentorship",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-32 lg:py-40 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <p className="text-xs uppercase tracking-[0.35em] text-amber-500 mb-6">
            — In their words
          </p>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight">
            What the inner <em className="italic text-amber-400">circle</em> says.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="rounded-3xl bg-[#0A0A0A] border border-white/10 p-8 lg:p-10 flex flex-col"
            >
              <div className="text-amber-500 font-serif-display text-6xl leading-none mb-4">
                "
              </div>
              <blockquote className="text-zinc-300 leading-relaxed text-lg flex-1">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/10">
                <div className="font-serif-display text-xl text-white">
                  {t.name}
                </div>
                <div className="text-xs uppercase tracking-[0.25em] text-zinc-500 mt-1">
                  {t.title}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
